import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import ModalFooter from 'CommonComponents/ModalFooter';
import TextareaFormField from 'CommonComponents/TextareaFormField';
import TextFormField from 'CommonComponents/TextFormField';

const StatusCreateSchema = Yup.object().shape({
    title: Yup.string().required($t('This value is required')),
    description: Yup.string().nullable(),
});

export default function GeneralRiskStatusCreateForm(props) {
    return (
        <Formik
            initialValues={{
                title: '',
                description: '',
            }}
            validationSchema={StatusCreateSchema}
            onSubmit={(values, actions) => {
                axios
                    .post(props.storeUrl, values)
                    .then((res) => {
                        props.onSuccess();
                        actions.resetForm();
                    })
                    .catch((e) => {
                        actions.setErrors(e.response.data.errors);
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                    });
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField
                            label={$t('Status')}
                            type="text"
                            required={true}
                            name="title"
                            placeholder={$t('Enter risk status title')}
                        ></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextareaFormField
                            label={$t('Description')}
                            as="textarea"
                            type="text"
                            name="description"
                            placeholder={$t('Enter risk status description')}
                        ></TextareaFormField>
                    </div>
                    <ModalFooter
                        cancelButtonText={$t('Cancel')}
                        primaryButtonText={$t('Save')}
                        onCancel={props.onCancel}
                        handleSubmit={handleSubmit}
                        isSubmitting={isSubmitting}
                    ></ModalFooter>
                </>
            )}
        </Formik>
    );
}
